import { useLocation } from 'react-router-dom'
export const Breadcrumb = () => {
    const location = useLocation()
    let exceptional = ["Performance","Shipment","Add Ons","Retailer Performance","Retailer Incentive","Vendors","Retailer Purchase Invoice","Customer Service","Sales Tele",]
    if(!exceptional.includes(getTitle(location.pathname))) {
        return (
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-flex align-items-center justify-content-between">
                        <h4 className="mb-0">{getTitle(location.pathname)}</h4>
                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                {/* <li className="breadcrumb-item"><a href="javascript: void(0);">Minible</a></li>
                                <li className="breadcrumb-item active">Dashboard</li> */}
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        );
    }else{
        return null
    }
}
const getTitle = (path) => {
    path = path.slice(1, path.length)
    path = path.split('-')

    let pathStr = path.map(str => {
        return str.charAt(0).toUpperCase() + str.slice(1)
    })

    return pathStr.join(' ')
}